<div app-layout>
  @if ((loading$ | async) === false) {
    @if (collections$ | async; as courses) {
      @if ((courses | noEmpty) && (collectionsSelected() | noEmpty)) {
        @for (collection of courses; track $index; let collectionIndex = $index) {
          @if (filtered(collection.id, collectionsSelected())) {
            <div>
              <div class="mb-4 flex items-center justify-between">
                <div class="flex items-center justify-start pl-2">
                  <svg-icon class="flex h-8 w-8 text-theme-500" src="assets/icons/icon-files.svg"></svg-icon>
                  <h2 class="mr-3 pl-5 text-2xl">{{ collection.nome }}</h2>
                  <p class="whitespace-nowrap text-md text-theme-500">
                    ({{ collection.cursos.length }} {{ 'trilhas.curso.cursos' | translate }})
                  </p>
                </div>
              </div>

              <div class="flex flex-wrap gap-4">
                @for (course of collection.cursos; track $index; let i = $index) {
                  @if (filtered(course.id, coursesSelected())) {
                    <div class="w-80">
                      <app-card-course [isShowcase]="true" [course]="course" (openCourse)="setCourseSelected($event)">
                      </app-card-course>
                    </div>
                  }
                }
              </div>
            </div>
          }
        }
      } @else {
        <ng-container *ngTemplateOutlet="empty"></ng-container>
      }
    } @else {
      <ng-container *ngTemplateOutlet="loading"></ng-container>
    }
  } @else {
    <ng-container *ngTemplateOutlet="loading"></ng-container>
  }
</div>

<ng-template #empty>
  <div class="h-[calc(100vh-10rem)] w-full p-5">
    <app-jumbotron translate>trilhas.lista-vazia</app-jumbotron>
  </div>
</ng-template>

<ng-template #loading>
  <div>
    <div class="container">
      <div class="mb-4 flex items-center justify-between">
        <div class="flex items-center justify-start pl-2">
          <svg-icon class="flex h-8 w-8 text-theme-500" src="assets/icons/icon-files.svg"></svg-icon>
          <app-skeleton class="ml-2 flex h-8! w-96!"></app-skeleton>
        </div>
      </div>

      <app-horizontal-scroll class="h-full">
        <div class="flex h-full w-fit gap-2 px-5">
          @for (item of [1, 2, 3]; track $index) {
            <app-card>
              <div app-card-content>
                <app-skeleton class="flex h-[23rem]! w-[200px]!"></app-skeleton>
              </div>
            </app-card>
          }
        </div>
      </app-horizontal-scroll>
    </div>
  </div>
</ng-template>
